import slugify from 'slugify';

export default function generateSlug(title: string, noSuffix = false): string {
  const random = Math.random().toString(36).slice(-5);
  const slug = slugify(title, {
    lower: true,
    strict: true,
  });
  return `${slug}${noSuffix ? '' : `-${random}`}`;
}
